export const QA_NAME_USER_AVATAR_GROUP = 'userAvatarGroup'

export const QA_NAME_USER_AVATAR_GROUP_MORE = 'userAvatarGroupMore'

export const USER_AVATAR_GROUP_DEFAULT_VISIBLE_COUNT = 3

export const USER_AVATAR_GROUP_MORE_TOOLTIP_SEPARATOR = ', '
